import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  container: {
    cursor: 'pointer',
    padding: 20,
    border: `1px solid ${theme.palette.colors.divider}`,
    borderRadius: theme.spacing(1),
    marginBottom: 15,
    boxShadow: 'rgb(0 0 0 / 12%) 0px 6px 16px 0px',
    [theme.breakpoints.up('mobile')]: {
      marginBottom: 0,
      borderRadius: 0,
      border: 'none',
      borderBottom: `1px solid ${theme.palette.colors.border}`,
      padding: [18, 24, 22, 20],
      boxShadow: 'none',
    },
  },
  loanOfficerInfo: {
    display: 'flex',
    alignItems: 'center',
  },
  avatarWithBadge: {
    position: 'relative',
  },
  avatar: {
    width: 52,
    height: 52,
    marginRight: theme.spacing(2),
  },
  unreadMessagesBadge: {
    backgroundColor: theme.palette.colors.red,
    height: 24,
    minWidth: 24,
    justifyContent: 'center',
    borderRadius: 12,
    display: 'flex',
    alignItems: 'center',
    position: 'absolute',
    top: -8,
    left: -8,
  },
  unreadMessagesText: {
    margin: [0, 6],
    color: theme.palette.colors.white,
  },
  info: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: 55,
    width: 150,
    [theme.breakpoints.up('mobile')]: {
      marginRight: 35,
    },
  },
  infoItem: {
    display: 'flex',
    alignItems: 'center',
  },
  name: {
    lineHeight: '20px',
  },
  onineStatus: {
    color: theme.palette.colors.white,
    width: 40,
    height: 16,
    backgroundColor: theme.palette.colors.lightGreen,
    borderRadius: 2,
    letterSpacing: '0.01em',
    textTransform: 'uppercase',
    marginLeft: 4,
    fontSize: 10,
    lineHeight: '16px',
    textAlign: 'center',
    padding: [0, 2],
  },
  companyName: {
    fontSize: 11,
    lineHeight: '16px',
  },
  companyLogotype: {
    marginLeft: 'auto',
    [theme.breakpoints.up('mobile')]: {
      marginLeft: 0,
    },
  },
  companyLogo: {
    height: 32,
    width: 70,
    objectFit: 'contain',
  },
  message: {
    margin: [theme.spacing(1), 0],
    display: '-webkit-box',
    '-webkit-line-clamp': 2,
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
  },
  active: {
    borderRight: `2px solid ${theme.palette.colors.red}`,
    backgroundColor: theme.palette.colors.lightGray,
  },
  inActive: {
    '&:hover': {
      borderRight: `2px solid ${theme.palette.colors.gray}`,
    },
  },
  bottomBar: {
    paddingTop: theme.spacing(2),
    marginTop: theme.spacing(2),
    borderTop: `1px solid ${theme.palette.colors.divider}`,
    display: 'flex',
    alignItems: 'center',
    height: 55,
  },
  bottomBarLeft: {
    width: 110,
  },
  bottomBarCenter: {
    width: 80,
  },
  bottomBarRight: {
    width: 80,
  },
  bidInfoText: {
    marginTop: 5,
    color: theme.palette.colors.darkBlueGray,
  },
  bold: {
    color: theme.palette.colors.emerald,
    opacity: 0.5,
  },
}));



// WEBPACK FOOTER //
// ./src/sharedComponents/LoanOfficerCard/useStyles.js